import * as firebase from 'firebase/app';

export type FirestoreTimestamp = firebase.firestore.Timestamp;

export const generateMockFirestoreTimestamp
    = (): FirestoreTimestamp => firebase.firestore.Timestamp.now();

export const generateCurrentFirestoreTimestamp
    = (): FirestoreTimestamp => <FirestoreTimestamp>firebase.firestore.FieldValue.serverTimestamp();
